import { UsersComponent } from "./components/dash-board/users/users.component";
import { UserProfileComponent } from "./components/user/user-profile/user-profile.component";
import { PostComponent } from "./components/news/post/post.component";
import { AddPostComponent } from "./components/dash-board/posts/add-post/add-post.component";
import { NewsComponent } from "./components/news/news.component";
import { AllBooksComponent } from "./components/dash-board/all-books/all-books.component";
import { NotfoundComponent } from "./components/notfound/notfound.component";
import { LoginComponent } from "./components/login/login.component";
import { RegisterComponent } from "./components/rigister/rigister.component";
import { UserBooksAComponent } from "./user-books/user-books.component";
import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { BooksComponent } from "./components/books/books.component";
import { FavoriteBooksComponent } from "./favorite-books/favorite-books.component";
import { BookComponent } from "./components/book/book.component";
import { AddBookComponent } from "./add-book/add-book.component";
import { EditBookComponent } from "./edit-book/edit-book.component";

import { AuthGuard } from "./Auth/auth.guard";
import { DashBoardComponent } from "./components/dash-board/dash-board.component";
import { AdminGuard } from "./Auth/admin.guard";
import { PostsComponent } from "./components/dash-board/posts/posts.component";

const routes: Routes = [
  {
    path: "",
    component: BooksComponent
  },
  {
    path: "books",
    component: BooksComponent
  },
  {
    path: "favoriteBooks",
    component: FavoriteBooksComponent
  },
  {
    path: "favoriteBooks/:book/:id",
    component: BookComponent
  },
  {
    path: "register",
    component: RegisterComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "login",
    component: LoginComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "book/:id",
    component: BookComponent
  },

  {
    path: "myBooks",
    component: UserBooksAComponent
  },
  {
    path: "admin",
    component: DashBoardComponent,
    canActivate: [AdminGuard],
    children: [
      {
        path: "",
        component: AllBooksComponent,
        canActivate: [AdminGuard]
      },

      {
        path: "addBook",
        component: AddBookComponent,
        canActivate: [AdminGuard]
      },
      {
        path: "editBook",
        component: EditBookComponent,
        canActivate: [AdminGuard]
      },
      {
        path: "posts",
        component: PostsComponent,
        canActivate: [AdminGuard]
      },

      {
        path: "addPost",
        component: AddPostComponent,
        canActivate: [AdminGuard]
      },
      {
        path: "users",
        component: UsersComponent
      }
    ]
  },
  {
    path: "user",
    component: UserProfileComponent
  },
  {
    path: "news",
    component: NewsComponent
  },
  {
    path: "news/:id",
    component: PostComponent
  },
  {
    path: "**",
    component: NotfoundComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
